/**
 * Кластеры и хозяйства для селекта «где видна» в карточке записи справочника.
 *
 * Макет (состояние 3, С-3): «Кластеры и хозяйства выбираются из одного списка,
 * их можно смешивать» — поэтому оба справочника тянем рядом и склеиваем в один
 * алфавитный список на стороне карточки.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ScopeOption {
  id: string;
  name: string;
}

export function useClusters(): UseQueryResult<ScopeOption[]> {
  return useQuery({
    queryKey: ['clusters'],
    queryFn: () => api.get<ScopeOption[]>('/api/v1/clusters'),
    staleTime: 5 * 60_000,
  });
}

export function useFarms(): UseQueryResult<ScopeOption[]> {
  return useQuery({
    queryKey: ['farms'],
    queryFn: () => api.get<ScopeOption[]>('/api/v1/farms'),
    staleTime: 5 * 60_000,
  });
}
